<template>
  <div>
    <DetailIndex :orderExpenseCode="params.code" />
  </div>
</template>
<script>
import DetailIndex from './components/detail'
export default {
  components: { DetailIndex },
  name: 'opview-order-expense',
  computed: {
    params() {
      return this.$route.params
    },
  },
}
</script>
